
import { createBrowserRouter } from 'react-router-dom';
import { publicRoutes } from './publicRoutes';
import { protectedRoutes } from './protectedRoutes';
import NotFound from '@/pages/NotFound';
import ScrollToTop from '@/components/layout/ScrollToTop';

const PublicPageLayout = ({ children }: { children: React.ReactNode }) => (
  <div className="min-h-screen bg-gradient-to-br from-background via-muted/40 to-background">
    <ScrollToTop />
    {children}
  </div>
);

export const router = createBrowserRouter([
  ...publicRoutes,
  ...protectedRoutes,
  {
    path: '*',
    element: (
      <PublicPageLayout>
        <NotFound />
      </PublicPageLayout>
    ),
  },
]);
